import state from './state';
import mutations from './mutations';
import actions from './actions';

export default {
  namespaced: true,
  actions,
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/group/index.js